const STATS = [
  { value: '2', label: 'Premium iOS Products' },
  { value: '99.9%', label: 'Uptime Reliability' },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-28 md:py-36 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Label */}
        <div className="flex justify-center mb-6">
          <span className="text-xs font-semibold tracking-widest uppercase text-emerald-600 border border-emerald-200 rounded-full px-4 py-1.5 bg-emerald-50">
            Our Story
          </span>
        </div>

        {/* Title */}
        <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 text-center leading-tight mb-6">
          Enhancing Mobile Experience
          <br />
          <span className="text-gray-400 font-light">Through Innovation</span>
        </h2>

        <p className="text-center text-gray-500 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-20">
          We are a dedicated team of iOS engineers and designers passionate about building applications that genuinely improve people&apos;s digital lives — making devices faster, safer, and smarter.
        </p>

        {/* Two-column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="w-full h-[420px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/92c31f4a2844a503932bc38e976b7cfe.jpg"
                alt="NEDZA DOO team at work"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-5 leading-snug">
              A Team Built Around Mobile Excellence
            </h3>
            <p className="text-gray-500 text-base leading-relaxed mb-5">
              NEDZA DOO was founded with a single mission: to create iOS applications that users can truly rely on. Our team combines deep technical expertise with a user-first design philosophy to deliver products that stand out in the App Store.
            </p>
            <p className="text-gray-500 text-base leading-relaxed mb-8">
              From enterprise-grade VPN solutions to intelligent device cleaners, every product we ship is built with precision, tested rigorously, and continuously improved based on real user feedback.
            </p>

            {/* Stats row */}
            <div className="grid grid-cols-2 gap-6">
              {STATS.map((stat) => (
                <div key={stat.label} className="bg-gray-50 rounded-xl p-5">
                  <div className="text-2xl font-extrabold text-gray-900 mb-1">{stat.value}</div>
                  <div className="text-xs text-gray-500 font-medium">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
